import { CubeQuery } from '../../../types/cube';
import { FilterType } from '@/models';

export const FilterKeys = {
  all: ['filter'] as const,
  filter: (type: FilterType, query: CubeQuery, isSecondarySegment?: boolean) =>
    ['filter', `type=${type}`, query, `isSecondarySegment=${Boolean(isSecondarySegment)}`] as const,
};
